import "core-js/modules/es6.regexp.to-string";

var CryptoJS = require('crypto-js');

import { JSEncrypt } from 'jsencrypt'; //Aes加密方法

export function AesEncrypt(word, keyStr) {
  var key = CryptoJS.enc.Utf8.parse(keyStr); //Latin1 w8m31+Yy/Nw6thPsMpO5fg==

  var srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
} //Aes解密方法

export function AesDecrypt(word, keyStr) {
  var key = CryptoJS.enc.Utf8.parse(keyStr); //Latin1 w8m31+Yy/Nw6thPsMpO5fg==

  var decrypt = CryptoJS.AES.decrypt(word, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
} //Rsa加密方法（使用服务端公钥，仅用于加密请求中的对称密钥 K）

export function RsaEncrypt(word) {
  var pubKey = "-----BEGIN PUBLIC KEY-----\nMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCxBY8Fme9nJDAg5B9I2TjUqm/heOMO3eiyXeD0gkXKt571JZMMNu/OEpk1iO3hUmVBJH1ke0U2js2CRgxT7ZaOgajWrRU+PeZ9SfqiubSmA0bd5XGHb5mvUHQmujWKq58nPQvX0WVFABqOTJWKHNZZi3nd\n//cEmzww5saf/DYgWQIDAQAB\n-----END PUBLIC KEY-----";
  var en = new JSEncrypt();
  en.setPublicKey(pubKey);
  return en.encrypt(word);
} // 请求级 AES 密钥暂存：sendParam 生成的 K 以 requestData 密文为 key 暂存，
// 供请求拦截器取出后挂到 axios config，响应拦截器用同源 K 解密响应。
// 由此前端不再需要持有客户端私钥（修复渗透测试 5.1 高危）。

export var requestKeyMap = {}; //获取随机字符串

export function randomString(e) {
  e = e || 32;
  var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
      a = t.length,
      n = "";

  for (var i = 0; i < e; i++) {
    n += t.charAt(Math.floor(Math.random() * a));
  }

  return n;
} //传参加密

export function sendParam(param) {
  var randomStr = this.randomString(16);
  var requestData = this.AesEncrypt(JSON.stringify(param), randomStr);
  var body = {
    "requestData": requestData,
    "encrypted": this.RsaEncrypt(randomStr) // 暂存对称密钥 K，供响应拦截器同源解密

  };
  requestKeyMap[requestData] = randomStr;
  return body;
} //出参解密（兼容写法：响应已由 request.js 拦截器统一同源解密，此处直接透传明文）

export function paramDecrypt(res) {
  // 兜底：若响应拦截器尚未解密，则尝试用暂存密钥解密
  if (res && res.data && res.data.requestData) {
    var k = requestKeyMap[res.data.requestData];

    if (k) {
      var result = JSON.parse(this.AesDecrypt(res.data.requestData, k));
      delete requestKeyMap[res.data.requestData];
      return result;
    }
  }

  return res && res.data ? res.data : res;
}